// src/utils/ProtectedRoute.jsx
import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";

const ProtectedRoute = ({ component: Component }) => {
  return withAuthenticationRequired(Component, {
    onRedirecting: () => <div>Cargando tu sesión...</div>,
  })();
};

export default ProtectedRoute;
